import { render, staticRenderFns } from "./OneFavoris.vue?vue&type=template&id=4c160806&"
import script from "./OneFavoris.vue?vue&type=script&lang=ts&"
export * from "./OneFavoris.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports